export const clubDrilldownQuery = ({ start, end, timezone, memberPage = 1, sessionPage = 1, limit = 25 }) => ({
  start, end, viewer_timezone: timezone, member_page: memberPage, member_limit: limit,
  session_page: sessionPage, session_limit: limit,
});

export const participationLabel = (member) => (
  member?.ever_participated ? 'Yes' : 'No recorded participation'
);

export const pageSummary = (page = {}) => (
  `${page.total_matching || 0} total · page ${page.page || 1} of ${page.total_pages || 1}`
);
